'use client';

import React, { HTMLAttributes, ReactNode, forwardRef } from 'react';
import { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/_utils/cn';
import { textVariants } from '../../lib/_utils/basic-variants';

const variants = cva([], {
  variants: {
    variant: {
      ...textVariants,
    },
  },
  compoundVariants: [],
  defaultVariants: {
    variant: 'success',
  },
});

type ValueColorBaseProp = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

type ValueColorProp = ValueColorBaseProp &
  VariantProps<typeof variants> & {
    variant?: string;
    size?: string;
  };

const ValueColor = forwardRef<HTMLDivElement, ValueColorProp>(
  ({ variant, className, children }, ref) => {
    return (
      <div
        ref={ref}
        className={`
        ${cn(variants({ variant }), className)}
      `}
      >
        {children}
      </div>
    );
  }
);

ValueColor.displayName = 'valueColor';

export default ValueColor;
